var React = require('react');

function TestimonialArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M39.694,8.139,31.7.3a1.045,1.045,0,0,0-1.463,0,1,1,0,0,0,0,1.437l6.225,6.112H1.04a1.022,1.022,0,1,0,0,2.043H36.463l-6.225,6.1a1,1,0,0,0,0,1.437,1.055,1.055,0,0,0,1.472,0L39.7,9.575A1.007,1.007,0,0,0,39.694,8.139Z","transform":"translate(0 -0.001)"}));
}

TestimonialArrow.defaultProps = {"viewBox":"0 0 40 17.723"};

module.exports = TestimonialArrow;

TestimonialArrow.default = TestimonialArrow;
